var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28,
    fill: "#23A26D",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0013 15.167C20.6546 15.167 14.668 21.1537 14.668 28.5003C14.668 35.847 20.6546 41.8337 28.0013 41.8337C35.348 41.8337 41.3346 35.847 41.3346 28.5003C41.3346 21.1537 35.348 15.167 28.0013 15.167ZM34.3746 25.4337L26.8146 32.9937C26.628 33.1803 26.3746 33.287 26.108 33.287C25.8413 33.287 25.588 33.1803 25.4013 32.9937L21.628 29.2203C21.2413 28.8337 21.2413 28.1937 21.628 27.807C22.0146 27.4203 22.6546 27.4203 23.0413 27.807L26.108 30.8737L32.9613 24.0203C33.348 23.6337 33.988 23.6337 34.3746 24.0203C34.7613 24.407 34.7613 25.0337 34.3746 25.4337Z",
    fill: "#23A26D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.4e2d4d198cf5a565187d49612284c97a.svg";
export { ForwardRef as ReactComponent };